module.exports = __webpack_public_path__ + "static/media/cornwall3-mobile.2845dd7a.jpg";